import { Text } from '@factorialco/deprecated-design-system'
import moment from 'moment'

import { observer } from 'mobx-react'

import type { Analytic } from 'modules/core/store/models/Analytic'

export interface Props {
  analytic?: Analytic<string | null>
}

const AnalyticTextResult = ({ analytic }: Props): JSX.Element | null => {
  if (!analytic || analytic.error) {
    return null
  }

  return (
    <Text.Normal weight="normal" color="grey1000">
      {moment(analytic?.results?.[0]?.value).fromNow(true)}
    </Text.Normal>
  )
}

export default observer(AnalyticTextResult)
